import { Discounts } from '@factorin/domain';

import { withUrl, list } from '../rest';


const discountSupplyRawsPart = withUrl('discountsupplyraws');

export const discountSupplyRaws = {
    list: list<Discounts.DiscountSupplyRaw>(discountSupplyRawsPart()).list,
};
